export default {
    namespaced: true,

    state: {
        previousPage: '',
    },

    mutations: {
        setPrevious(state, payload) {
            state.previousPage = payload;
        },
    },
}